import React, { useCallback, useMemo } from 'react';
import { View } from 'react-native';
import { useAppIcon } from 'features/app-icons/hooks';
import Modal from 'utils/packages/Modal';
import AppIconItem from 'features/app-icons/components/AppIconItem';
import { isUnlocked } from 'features/premium/isUnlocked';
import APP_ICONS, { CHRISTMAS_APP_ICON, } from 'features/app-icons/appIcons';
import { rem } from 'design-system';
import { useAppSelector } from 'store/hooks';
import { selectUserTier } from 'features/premium/selectors/tier';
import { isChristmasIconAvailable } from 'features/app-icons/hooks/useAppIcons';
const strings = {
    title: 'Choose an icon',
};
const SelectAppIconModal = () => {
    const userTier = useAppSelector(selectUserTier);
    const isCrowdfundingInvestor = useAppSelector((store) => store.user.user.isCrowdfundingInvestor);
    const [currentIcon, switchIcon] = useAppIcon();
    const onIconPress = useCallback((newIcon) => {
        switchIcon(newIcon);
        SelectAppIconModal.hide();
    }, [switchIcon]);
    const isChristmas = useMemo(isChristmasIconAvailable, []);
    const iconItems = APP_ICONS.map((iconItem) => {
        const selected = currentIcon?.name === iconItem.name;
        const locked = 
        // eslint-disable-next-line no-nested-ternary
        iconItem.name === 'investor'
            ? !isCrowdfundingInvestor
            : iconItem?.tier
                ? !isUnlocked(userTier, iconItem.tier)
                : false;
        if (iconItem.name === CHRISTMAS_APP_ICON.name &&
            !(isChristmas || currentIcon?.name === CHRISTMAS_APP_ICON.name)) {
            return null;
        }
        return (<AppIconItem locked={locked} appIcon={iconItem} key={iconItem.name} selected={selected} onPress={onIconPress} disabled={iconItem.name === 'investor' && !isCrowdfundingInvestor}/>);
    });
    return <View>{iconItems}</View>;
};
const SelectAppIconModalMemo = React.memo(SelectAppIconModal);
SelectAppIconModal.show = () => {
    Modal.show(<SelectAppIconModalMemo />, {
        title: strings.title,
        containerStyle: {
            paddingHorizontal: 0,
        },
        scrollable: {
            maxHeight: rem(500),
        },
    });
};
SelectAppIconModal.hide = () => {
    Modal.hide();
};
export default SelectAppIconModal;
